import { render, staticRenderFns } from "./lockers.vue?vue&type=template&id=3be4be64&"
import script from "./lockers.vue?vue&type=script&lang=js&"
export * from "./lockers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports